import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { login } from '../api/auth';
import { CenteredLayout } from '../components/PageLayout';
import Card from '../components/Card';
import Input from '../components/Input';
import Button from '../components/Button';
import Alert from '../components/Alert';

export default function LoginPage() {
  const { login: authLogin } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const { data } = await login(form.email, form.password);
      authLogin(data.user, data.access, data.refresh);
      navigate('/');
    } catch (err) {
      const status = err.response?.status;
      if (status === 401 || status === 403) {
        setError(err.response.data?.detail || '邮箱或密码错误');
      } else if (status === 429) {
        setError(err.response?.data?.detail || '操作过于频繁，请稍后再试');
      } else if (status >= 500 || !status) {
        setError('服务器暂时不可用，请稍后重试');
      } else {
        setError(err.response?.data?.detail || '登录失败，请稍后重试');
      }
    } finally { setLoading(false); }
  };

  return (
    <CenteredLayout>
      <div style={{textAlign:'center',marginBottom:32}}>
        <Link to="/" style={{fontWeight:800,fontSize:24,color:'var(--color-primary)'}}>AIQ 测评</Link>
        <h1 style={{fontSize:22,fontWeight:700,marginTop:16,marginBottom:4}}>欢迎回来</h1>
        <p style={{color:'var(--color-text-secondary)',fontSize:14}}>登录你的 AIQ 账号</p>
      </div>
      <Card>
        {error && <Alert type="error">{error}</Alert>}
        <form onSubmit={handleSubmit}>
          <Input label="邮箱" type="email" value={form.email} required
            onChange={e=>setForm({...form,email:e.target.value})} placeholder="your@email.com"/>
          <Input label="密码" type="password" value={form.password} required
            onChange={e=>setForm({...form,password:e.target.value})} placeholder="输入密码"/>
          <div style={{textAlign:'right',marginTop:-10,marginBottom:20}}>
            <Link to="/reset-password" style={{fontSize:13,color:'var(--color-secondary)'}}>忘记密码？</Link>
          </div>
          <Button type="submit" fullWidth loading={loading}>登录</Button>
        </form>
      </Card>
      <p style={{textAlign:'center',marginTop:20,fontSize:14,color:'var(--color-text-secondary)'}}>
        还没有账号？<Link to="/register" style={{color:'var(--color-secondary)',fontWeight:600}}>立即注册</Link>
      </p>
    </CenteredLayout>
  );
}
